import React from 'react';
import * as Styled from './ImageAndTable.styles';
export var ImageAndTable = function ImageAndTable(_ref) {
  var heading = _ref.heading,
      imageURL = _ref.imageURL,
      tableData = _ref.tableData;
  var displayData = tableData.map(function (property) {
    var sectionLetter = property.sectionLetter,
        sectionProperty = property.sectionProperty,
        size = property.size;
    return /*#__PURE__*/React.createElement(Styled.TableRow, {
      key: sectionLetter
    }, /*#__PURE__*/React.createElement(Styled.LetterWrapper, null, sectionLetter), /*#__PURE__*/React.createElement(Styled.PropertyWrapper, null, sectionProperty), /*#__PURE__*/React.createElement(Styled.SizeWrapper, null, size));
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Styled.Heading, null, /*#__PURE__*/React.createElement("strong", null, heading)), /*#__PURE__*/React.createElement(Styled.FlexWrapper, null, /*#__PURE__*/React.createElement(Styled.ImageContainer, null, imageURL && /*#__PURE__*/React.createElement(Styled.Image, {
    src: imageURL,
    alt: "".concat(heading, " product image"),
    width: 450
  })), displayData.length ? /*#__PURE__*/React.createElement(Styled.TableContainer, null, /*#__PURE__*/React.createElement("table", null, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement(Styled.TableRow, null, /*#__PURE__*/React.createElement(Styled.TableHeader, null, "\xA0"), /*#__PURE__*/React.createElement(Styled.TableHeader, null, "Section"), /*#__PURE__*/React.createElement(Styled.TableHeaderCentre, null, "Dimensions (cm)")), displayData))) : null));
};